<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.logo-list {
    .logo {
        width: auto;
        height: 48px;
        margin: 0 auto 0 auto;
        padding: 0 8px;

        &:first-of-type {
            padding-left: 0;
        } 

        &:last-of-type {
            padding-right: 0;
        } 

        @media screen and (min-width: $screen-md) {
            height: 61px;
            padding: 0 50px;
            margin: 0 auto 0 auto;
        }

        .image-wrapper {
            width: 88px;
            height: 100%;

            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            margin: 0 auto 24px auto;

            @media screen and (min-width: $screen-md) {
                width: 112px;
                margin: 0 auto 40px auto;
            }
        }
    }
}
</style>

<template>
    <div class="logo-list mb-32 d-flex flex-wrap justify-content-between">
        <div class="logo" v-for="(image,index) in imageArray" :key="index">
            <div class="image-wrapper lazyload" :data-bg="image"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        imageArray: {
            type: Array,
            required: false,
        },
    },
}
</script>